import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import ReportsArchive from "@/pages/ReportsArchive";
import CostAvoidance from "@/pages/CostAvoidance";
import SupplyChain from "@/pages/SupplyChain";
import Procurement from "@/pages/Procurement";
import BudgetAssumptions from "@/pages/BudgetAssumptions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/:id"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsArchive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cost-avoidance"
              element={
                <ProtectedRoute>
                  <CostAvoidance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supply-chain"
              element={
                <ProtectedRoute>
                  <SupplyChain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/budget-assumptions"
              element={
                <ProtectedRoute>
                  <BudgetAssumptions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/procurement"
              element={
                <ProtectedRoute>
                  <Procurement />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
